import { Center, Box, Button, Flex, Heading, HStack, Icon, Show } from '@chakra-ui/react';
import { BsQrCode } from 'react-icons/bs';
import { AvatarWithDefaultIcon } from '../../AvatarWithDefaultIcon';
import { EditDataBtn } from '../../Buttons/EditDataBtn';
import { HiOutlineMagnifyingGlassPlus } from 'react-icons/hi2';
import { LinkWithArrow } from '../../Links/LinkWithArrow';
import { useTranslation } from 'react-i18next';

export interface IMember {
  firstName?: string;
  lastName?: string;
  onClickCodeIcon?: VoidFunction;
  onClickEdit?: VoidFunction;
  onClickScore?: VoidFunction;
}

export const Member = (props: IMember) => {
  const { t } = useTranslation();
  const { firstName, lastName, onClickCodeIcon, onClickEdit, onClickScore } = props;

  return (
    <HStack w='100%' spacing={{ base: 1, lg: 8 }}>
      <Show above='lg'>
        <AvatarWithDefaultIcon size='xl' />
      </Show>

      <Box flexGrow={1}>
        <Heading fontSize='xl'>{`${firstName} ${lastName}`}</Heading>
        <Box mt={1}>
          <LinkWithArrow to='#' onClick={onClickScore}>
            {t('member.view.score.btn')}
          </LinkWithArrow>
        </Box>
        <Box mt={2}>
          <EditDataBtn onClick={onClickEdit}>{t('members.edit.btn')}</EditDataBtn>
        </Box>
      </Box>

      <Show above='lg'>
        <Button
          w='109px'
          h='109px'
          borderRadius={12}
          variant='white'
          background='brand.white'
          padding={6}
          _hover={{
            '.hover-indicator': {
              opacity: 1,
            },
          }}
          overflow='hidden'
          onClick={onClickCodeIcon}
        >
          <Icon as={BsQrCode} boxSize='100%' />
          <Icon
            className='hover-indicator'
            opacity={0}
            borderRadius={12}
            as={HiOutlineMagnifyingGlassPlus}
            background='brand.cyanOpacity'
            position='absolute'
            w='100%'
            h='100%'
            padding={9}
            color='brand.white'
            sx={{ transition: 'all .25s ease-in-out' }}
          />
        </Button>
      </Show>

      {/* ──── Mobile ──────────────────────────────────────────────────────────────────────────── */}
      <Show below='lg'>
        <Flex alignItems='center'>
          <Center
            borderRadius='50%'
            background='brand.offBlack'
            w='40px'
            h='40px'
            mr={1}
            zIndex={1}
            sx={{ transition: 'all .25s ease-in-out' }}
            _hover={{ cursor: 'pointer', boxShadow: '0 0 5px var(--chakra-colors-brand-cyan)' }}
            onClick={onClickCodeIcon}
          >
            <Icon as={BsQrCode} boxSize='55%' color='brand.cyan' />
          </Center>
          <AvatarWithDefaultIcon width='74px' />
        </Flex>
      </Show>
    </HStack>
  );
};
